import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ButtonComp(props) {
	const { title, icon, className } = props;
	return (
		<>
			{className ? (
				<Button
					className={`primaryButton ${className} `}
					onClick={props.onClick}
				>
					{title}
					{icon ? (
						<FontAwesomeIcon className="buttonIcon" icon={icon} />
					) : null}
				</Button>
			) : (
				<Button className="primaryButton" onClick={props.onClick}>
					{title}
					{icon ? (
						<FontAwesomeIcon className="buttonIcon" icon={icon} />
					) : null}
				</Button>
			)}
		</>
	);
}

export default ButtonComp;
